<div class="container mt-4">
  <div class="row">
    <form class="form">
      <div class="d-block d-md-flex justify-content-center">
        <div class="infoContainer">
          <h3>{{ "Contact Us" | transloco }}</h3>
          <!-- <div class="form-container">
            <div class="form-group">
              <label for="name" class="form-label">{{
                "Name" | transloco
              }}</label>
              <input
                class="form-control"
                type="text"
                id="name"
                formControlName="name"
                [(ngModel)]="name"
              />
            </div>
            <div class="form-group">
              <label for="email" class="form-label">{{
                "Email" | transloco
              }}</label>
              <input
                class="form-control"
                type="email"
                id="email"
                formControlName="email"
                [(ngModel)]="email"
              />
            </div>
            <div class="form-group">
              <label for="message" class="form-label">{{
                "Message" | transloco
              }}</label>
              <textarea
                class="form-control"
                id="message"
                rows="5"
                placeholder="Message"
                formControlName="message"
                [(ngModel)]="message"
              >
              </textarea>
            </div>
            <div class="form-group mb-2">
              <button
                type="submit"
                class="btn cusmoizeBtn"
                [disabled]="Data.invalid"
                [ngClass]="{ disabled: Data.invalid }"
              >
                {{ "Send" | transloco }}
              </button>
            </div>
          </div> -->
          <p>
            {{ "Email" | transloco }}:<span class="info ms-2">bluebox&#64;gmail.com</span>
          </p>
          <p>
            {{ "phone" | transloco }}:<span class="info ms-2">01103325333</span>
          </p>
          <p>
            <img src="/assets/logos_facebook.png" alt="facebook" class="socialImg ms-2" /><span
              class="info">bluebox</span>
          </p>
          <p>
            <img src="/assets/skill-icons_linkedin.png" alt="linkedIn" class="socialImg ms-2" /><span
              class="info">bluebox</span>
          </p>
          <p>
            <img src="/assets/skill-icons_instagram.png" alt="instagram" class="socialImg ms-2" /><span
              class="info">bluebox</span>
          </p>

        </div>
        <div class="d-none d-md-flex justify-content-center w-50">
          <div class="box">
            <div class="d-flex item-image justify-content-center">
              <img src="/assets/contact-us.png" alt="ContactUsImage" class="ContactUsImage" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>